import { useState } from 'react'
import { createParam } from 'solito'
import { OfferCategoryScreen } from './offer-category-screen'
import { useCategoryOffersQuery, useOfferCategoryQuery } from './queries'

const { useParam } = createParam<{ slug: string }>()

export interface OfferCategoryScreenContainerProps {
  preview?: boolean
}

export const OfferCategoryScreenContainer = (props: OfferCategoryScreenContainerProps) => {
  const [slug] = useParam('slug')
  const [refreshing, setRefreshing] = useState(false)
  const {
    loading: offerCategoryLoading,
    data: offerCategoryData,
    refetch: refetchOfferCategory,
    error,
  } = useOfferCategoryQuery({ slug: slug || '', draft: !!props.preview })

  const offerCategoryId = offerCategoryData?.OfferCategories?.docs?.[0]?.id || ''

  const {
    data: categoryOffersData,
    fetchMore,
    refetch: refetchCategoryOffers,
    networkStatus,
  } = useCategoryOffersQuery({
    variables: {
      category: offerCategoryId,
      page: 1,
      limit: 6,
    },
    skip: !offerCategoryId,
    notifyOnNetworkStatusChange: true,
  })

  const handlePullToRefresh = async () => {
    setRefreshing(true)
    await Promise.all([refetchOfferCategory(), refetchCategoryOffers()])
    setRefreshing(false)
  }

  const hasMore =
    (categoryOffersData?.fetchOffers?.page || 0) <
    (categoryOffersData?.fetchOffers?.totalPages || 0)

  const handleLoadMore = () => {
    fetchMore({
      variables: {
        page: (categoryOffersData?.fetchOffers?.page || 0) + 1,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return prev
        }
        return {
          fetchOffers: {
            ...fetchMoreResult.fetchOffers,
            docs: [...(prev.fetchOffers?.docs || []), ...(fetchMoreResult.fetchOffers?.docs || [])],
          },
        }
      },
    })
  }

  return (
    <OfferCategoryScreen
      loading={offerCategoryLoading}
      category={offerCategoryData?.OfferCategories?.docs?.[0]}
      offers={categoryOffersData?.fetchOffers?.docs || []}
      error={error}
      hasMore={hasMore}
      loadingMore={networkStatus === 3}
      onLoadMore={handleLoadMore}
      refreshing={refreshing}
      onPullToRefresh={handlePullToRefresh}
    />
  )
}
